import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import NewTriggerModal from "../../components/NewTriggerModal";
import PortalPopup from "../../components/PortalPopup";
import ToastMsg from "../../components/ToastMsg";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import Toggle from "../../components/Toggle";
import NavigationPanel from "../../components/NavigationPanel";
import Breadcrumb from "../../components/Breadcrumb";
import CTAs from "../../components/CTAs";
import Dropdown from "../../components/Dropdown";
import Footer from "../../components/Footer";
import SettingNav from "../../components/settingNav";
import { ArrowDown2 } from "iconsax-reactjs";

const SettingsPreferencesPage = () => {
  const navigate = useNavigate();
  const [isNewTriggerModalOpen, setNewTriggerModalOpen] = useState(false);
  const [isToastMsgOpen, setToastMsgOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const openNewTriggerModal = useCallback(() => {
    setNewTriggerModalOpen(true);
  }, []);

  const closeNewTriggerModal = useCallback(() => {
    setNewTriggerModalOpen(false);
  }, []);

  const openToastMsg = useCallback(() => {
    setToastMsgOpen(true);
  }, []);

  const closeToastMsg = useCallback(() => {
    setToastMsgOpen(false);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  // const dropdownContents = ["SMS", "Email", "Phone call"];

  const handleToggle = (state) => {
    console.log("Toggle state is:", state);
  };

  // For table
  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const action_triggers = [
    {
      name: "Payment delay",
      condition: "If payment is delayed by more than 14 days.",
      associated_action: "Escalate the case to legal proceedings.",
      action: "",
    },
    {
      name: "Defence raised",
      condition: "If defence is raised by the debtor.",
      associated_action: "Schedule a communication with him.",
      action: "",
    },
    {
      name: "Billing schedule",
      condition: "If court proceedings go beyond 7 days.",
      associated_action: "Initiate billing schedule.",
      action: "",
    },
    {
      name: "Payment delay",
      condition: "If payment is delayed by more than 14 days.",
      associated_action: "Escalate the case to legal proceedings.",
      action: "",
    },
    {
      name: "Payment delay",
      condition: "If payment is delayed by more than 14 days.",
      associated_action: "Escalate the case to legal proceedings.",
      action: "",
    },
  ];

  const filteredTriggers =
    activeTab === "all"
      ? action_triggers
      : action_triggers.filter(
          (debtor) => debtor.status.toLowerCase() === activeTab.toLowerCase()
        );

  const searchedTriggers = filteredTriggers.filter(
    (debtor) =>
      debtor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.condition.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.associated_action
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      debtor.action.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-base text-neutrals-neutral-900 font-open-sans-ff-body-strong">
        {/* Navigation Panel */}
        <NavigationPanel />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 px-4 md:px-4 lg:px-24 box-border">
          <div className="self-stretch flex flex-col items-start justify-start gap-6 text-9xl text-primary-primary-900">
            {/* Heading */}
            <div className="self-stretch bg-white border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-col items-start justify-start pt-0 px-0 pb-6 gap-1.5">
              <b className="self-stretch relative">Settings</b>
              <div className="self-stretch relative text-base text-neutrals-neutral-300">
                Get your billing information, generate/review invoices.
              </div>
            </div>

            <div className="self-stretch flex flex-row items-start justify-start gap-8 text-base text-neutrals-neutral-300">
              {/* Tabs */}
              <SettingNav />

              {/* Right side */}
              <div className="w-full flex-1 self-stretch flex flex-col items-start justify-start gap-6 text-lg text-neutrals-neutral-900">
                <div className="self-stretch border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-row items-start justify-between pt-0 px-0 pb-6 gap-0">
                  <div className="flex-1 flex flex-col items-start justify-start gap-1.5">
                    <div className="relative font-semibold">Preferences</div>
                    <div className="relative text-sm leading-[20px] font-inter text-neutrals-neutral-300">
                      Customise how your workspace looks, behaves, and automates
                      everyday actions.
                    </div>
                  </div>
                  <div className="flex flex-row items-start justify-end gap-3 text-sm">
                    <CTAs
                      type="Secondarybtn"
                      text="Cancel"
                      borderColor="border-neutrals-neutral-100"
                      position="relative"
                    />

                    <CTAs
                      type="Gradientbtn"
                      text="Save"
                      borderColor="border-primary-primary-500"
                      position="relative"
                      onClick={openToastMsg}
                    />
                  </div>
                </div>

                <div className="self-stretch flex flex-col items-start gap-5 text-sm text-neutrals-neutral-900">
                  <div className="w-[512px] flex items-center gap-8 text-neutrals-neutral-900">
                    <div className="flex-1 flex flex-col items-start">
                      <div className="self-stretch relative font-semibold">
                        Language
                      </div>
                      <div className="self-stretch relative text-neutrals-neutral-300">
                        Default language for the system.
                      </div>
                    </div>
                    <div className="w-[200px] rounded-lg bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex items-center py-2 px-3 gap-1.5 text-base">
                      <div className="flex-1 flex items-center gap-2">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_10429_13521)">
                            <path
                              d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                              fill="#F0F0F0"
                            />
                            <path
                              d="M2.06742 3.91016C1.28191 4.93215 0.689609 6.11008 0.344727 7.38973H5.54699L2.06742 3.91016Z"
                              fill="#0052B4"
                            />
                            <path
                              d="M19.6558 7.38969C19.3109 6.11008 18.7186 4.93215 17.9331 3.91016L14.4536 7.38969H19.6558Z"
                              fill="#0052B4"
                            />
                            <path
                              d="M0.344727 12.6094C0.689648 13.889 1.28195 15.0669 2.06742 16.0889L5.54688 12.6094H0.344727Z"
                              fill="#0052B4"
                            />
                            <path
                              d="M16.0884 2.06648C15.0664 1.28098 13.8885 0.688672 12.6089 0.34375V5.54598L16.0884 2.06648Z"
                              fill="#0052B4"
                            />
                            <path
                              d="M3.91211 17.9326C4.9341 18.7181 6.11203 19.3104 7.39164 19.6553V14.4531L3.91211 17.9326Z"
                              fill="#0052B4"
                            />
                            <path
                              d="M7.3916 0.34375C6.11199 0.688672 4.93406 1.28098 3.91211 2.06645L7.3916 5.54594V0.34375Z"
                              fill="#0052B4"
                            />
                            <path
                              d="M12.6089 19.6553C13.8885 19.3104 15.0664 18.7181 16.0884 17.9326L12.6089 14.4531V19.6553Z"
                              fill="#0052B4"
                            />
                            <path
                              d="M14.4536 12.6094L17.9331 16.0889C18.7186 15.067 19.3109 13.889 19.6558 12.6094H14.4536Z"
                              fill="#0052B4"
                            />
                            <path
                              d="M19.9154 8.69566H11.3044H11.3044V0.0846484C10.8774 0.0290625 10.4421 0 10 0C9.55785 0 9.12262 0.0290625 8.69566 0.0846484V8.69559V8.69563H0.0846484C0.0290625 9.12262 0 9.55793 0 10C0 10.4421 0.0290625 10.8774 0.0846484 11.3043H8.69559H8.69563V19.9154C9.12262 19.9709 9.55785 20 10 20C10.4421 20 10.8774 19.971 11.3043 19.9154V11.3044V11.3044H19.9154C19.9709 10.8774 20 10.4421 20 10C20 9.55793 19.9709 9.12262 19.9154 8.69566V8.69566Z"
                              fill="#D80027"
                            />
                            <path
                              d="M12.6089 12.6094L17.0712 17.0718C17.2765 16.8666 17.4722 16.6521 17.659 16.4298L13.8387 12.6094H12.6089V12.6094Z"
                              fill="#D80027"
                            />
                            <path
                              d="M7.39109 12.6094H7.39102L2.92871 17.0717C3.13387 17.2769 3.34836 17.4727 3.5707 17.6595L7.39109 13.839V12.6094Z"
                              fill="#D80027"
                            />
                            <path
                              d="M7.39146 7.39215V7.39207L2.92912 2.92969C2.72389 3.13484 2.52811 3.34934 2.34131 3.57168L6.16174 7.39211H7.39146V7.39215Z"
                              fill="#D80027"
                            />
                            <path
                              d="M12.6089 7.39004L17.0713 2.92762C16.8661 2.72238 16.6516 2.5266 16.4293 2.33984L12.6089 6.16027V7.39004Z"
                              fill="#D80027"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_10429_13521">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>

                        <div className="relative font-semibold">
                          English (UK)
                        </div>
                      </div>
                      <ArrowDown2 size={16} />
                    </div>
                  </div>
                  <div className="w-[512px] flex flex-col items-start gap-1.5">
                    <div className="relative font-semibold">
                      Default currency
                    </div>
                    <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex items-end py-3 px-2.5 gap-[177px] text-base text-neutrals-neutral-900">
                      <div className="flex-1 relative font-semibold">
                        British Pound (£)
                      </div>
                      <ArrowDown2 size={20} />
                    </div>
                  </div>
                  <div className="w-[512px] flex flex-col items-start gap-1.5">
                    <div className="relative font-semibold">Date format</div>
                    <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex items-end py-3 px-2.5 gap-[177px] text-base text-neutrals-neutral-900">
                      <div className="flex-1 relative font-semibold">
                        DD/MM/YYYY
                      </div>
                      <ArrowDown2 size={20} />
                    </div>
                  </div>
                  <div className="w-[512px] flex flex-col items-start gap-1.5">
                    <div className="relative font-semibold">
                      Default case type
                    </div>
                    <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex items-end py-3 px-2.5 gap-[177px] text-base text-neutrals-neutral-900">
                      <div className="flex-1 relative font-semibold">
                        Pre-LBA
                      </div>
                      <ArrowDown2 />
                    </div>
                  </div>
                  <div className="self-stretch h-px relative border-neutrals-neutral-100 border-solid border-t-[1px] box-border" />
                  <div className="w-[512px] h-[38px] flex items-start gap-8 text-neutrals-neutral-900">
                    <div className="flex-1 flex flex-col items-start">
                      <div className="self-stretch relative font-semibold">
                        Email notifications
                      </div>
                      <div className="self-stretch relative text-slategray">
                        Get notified whenever any debt is settled.
                      </div>
                    </div>
                    <Toggle />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      {isNewTriggerModalOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeNewTriggerModal}
        >
          <NewTriggerModal onClose={closeNewTriggerModal} />
        </PortalPopup>
      )}
      {isToastMsgOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeToastMsg}
        >
          <ToastMsg onClose={closeToastMsg} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default SettingsPreferencesPage;
